import { TrainingClassTrainerSurveyURLArray } from './training.class.trainer.surveyurl';
import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export class TrainingClass {
    ID: number;
    Created: Date;
    Modified: Date;
    ClassName: string;
    ClassDuration: string;
    ProductIDs: number[];
    ClassCredits: number;
    LevelOrder: number;
    ClassTitle: string;
    PreviewText: string;
    ClassDescription: string;
    TrainerID: number;
    TrainerName: string;
    TrainerEmail: string;
    Explanation: string;
    IntroductoryVideoLabel: string;
    IntroductoryVideoURL: string;
    DimensionsGuideLabel: string;
    DimensionsGuideURL: string;
    TrainingDesignURL: string;
    FollowupSteps: string;
    APSPCertificate: boolean;
    FundamentalsClass: boolean;
    EmailTemplateReminder: string;
    EmailTemplateNoShows: string;
    EmailTemplateSetup: string;
    EmailTemplateCertificate: string;
    EmailTemplateRegistrationConfirmation: string;
    EmailTemplateSelfCancel: string;
    TrainingClassTrainerSurveyURLs: TrainingClassTrainerSurveyURLArray;
    MinimumSoftwareVersionInt: number;
    MaximumSoftwareVersionInt: number;
    //
    OrderFormVisible: boolean;
    OrderFormDisplayName: string;
    OrderFormValue: number;
    OrderFormPrice: number;
    
    public static FixDates(item: TrainingClass) {
        item.Created = new Date(item.Created);
        item.Modified = new Date(item.Modified);
    }

}

export class TrainingClassArray extends Array<TrainingClass> {
    LastSort: SortItem;

    constructor(...items: TrainingClass[]) {
        super(...items);
        Object.setPrototypeOf(this, TrainingClassArray.prototype);
        this.LastSort = new SortItem();
    }

    public static FixDates(item: TrainingClassArray) {
        item.forEach(x => TrainingClass.FixDates(x));
    }

}
